import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { holidayRatesSelector, fetchHolidayRates, updateHolidayRate, addHolidayRate } from 'slices/holidayRateSlice';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { CustomSwitch } from 'components/common/Switch';


const AddHolidayRateForm = ({ item, handleClose, callback, statusPerm }) => {
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState({
        holiday_name: '',
        start_date: '',
        end_date: '',
        holiday_rate: '',
        travel_rate: '',
        status: 1
    });

    const { error, loader } = useSelector(holidayRatesSelector);

    // Populate form when editing
    useEffect(() => {
        if (item?.id) {
            setFormValues({
                holiday_name: item?.holiday_name || "",
                start_date: item?.start_date || "",
                end_date: item?.end_date || "",
                holiday_rate: item?.holiday_rate || "",
                travel_rate: item?.travel_rate || "",
                status: item?.status === 1 ? 1 : 0
            });
        } else {
            setFormValues({
                holiday_name: '',
                start_date: '',
                end_date: '',
                holiday_rate: '',
                travel_rate: '',
                status: 1
            });
        }
    }, [item]);

    // Handle input change
    const handleChange = (e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    };


    const handleStatusChange = (checked) => {
        setFormValues((prev) => ({ ...prev, status: checked ? 1 : 0 }));
    };

    // Callback after API call
    const submitCallback = (status, message) => {
        if (status) {
            callback();
            toast.success(message, { className: "successToast" });
            dispatch(fetchHolidayRates());
            handleClose();
        } else {
            toast.error(message, { className: "errorToast" });
        }
    };

    // Submit form
    const handleSubmit = (event) => {
        event.preventDefault();
        if (item?.id) {
            dispatch(updateHolidayRate(formValues, item?.id, submitCallback));
        } else {
            dispatch(addHolidayRate(formValues, submitCallback));
        }
    };

    return (
        <form onSubmit={handleSubmit}>
        
            <div className="row-primary">
                <h2>Holiday Name *</h2>
                <input
                    onChange={handleChange}
                    required
                    name="holiday_name"
                    className="input-in type_inp"
                    type="text"
                    placeholder="Holiday Name"
                    value={formValues.holiday_name}
                />
            </div>

            <div className="row-primary">
                <h2>Start Date *</h2>
                <div class="input-image" style={{padding: '0px'}}>
                <input
                    onChange={handleChange}
                    required
                    name="start_date"
                    className="input-in type_inp"
                    type="date"
                    value={formValues.start_date}
                    style={{height: '45px'}}    
                />
                    <img alt="celender Icon" class="custom-icon" src="/images/celender.png"></img>
                </div>
            </div>

            <div className="row-primary">
                <h2>End Date *</h2>
                <div class="input-image" style={{padding: '0px'}}>
                <input
                    onChange={handleChange}
                    required
                    name="end_date"
                    className="input-in type_inp"
                    type="date"
                    value={formValues.end_date}
                    style={{height: '45px'}} 
                />
                    <img alt="celender Icon" class="custom-icon" src="/images/celender.png"></img>
                </div>
            </div>

            <div className="row-primary">
                <h2>Holiday Rate *</h2>
                <input
                    onChange={handleChange}
                    required
                    name="holiday_rate"
                    className="input-in type_inp"
                    type="number"
                    placeholder="Holiday Rate"
                    value={formValues.holiday_rate}
                />
            </div>

                {statusPerm && (
                <div className="row-primary flex-row align-items-center" style={{ alignItems: 'center' }}>
                    <h2 className="mt-0">Status</h2>
                    <CustomSwitch labelText="active" checked={formValues.status === 1} handleChange={handleStatusChange} />
                </div>
            )}

            {error?.errors &&
                Object.keys(error.errors).map((key) =>
                    error.errors[key].map((errMsg, i) => (
                        <div key={i} style={{ marginBottom: 10 }}>
                            <ErrorMessage text={errMsg} />
                        </div>
                    ))
                )}

            <div className="Form-footer">
                <button type="button" className="Cancle_button" onClick={handleClose}>
                    Cancel
                </button>
                <SubmitButton btnText={item?.id ? "Update" : "Create"} loader={loader} />
            </div>
        </form>
    );
};

const AddHolidayRate = ({ show, item, onClose, callback, statusPerm }) => {
    return (
        <Modal isOpen={show} toggle={onClose} centered className="modal-medium">
            <div className="modal-content full_modal">
                <div className="modal-header header_modal align-items-center">
                    <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Holiday Rate</h5>
                    <button type="button" className="btn-close" onClick={onClose}></button>
                </div>
                <div className="modal-body modal_form_body">
                    <AddHolidayRateForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm} />
                </div>
            </div>
        </Modal>
    );
};


export default AddHolidayRate;
